// extracted by mini-css-extract-plugin
export default {"wave":"svg_wave__28y5A","wave_fill":"svg_wave_fill__ZTeEi"};